import React, { FC } from 'react';
import classNames from 'classnames';

import styles from './container.module.scss';

type Props = {
  className?: string;
};

export const Container: FC<Props> = ({ children, className }) => {
  const containerClass = classNames(styles.container, className);
  return <div className={containerClass}>{children}</div>;
};
